export default {
  namespaced: true,
  ai_analytics_servers: {
    title: "Servidores de Análise de IA",
    servers: "Servidores",
    server: "Servidor",
    server_name: "Nome do Servidor",
    service_name: "Nome do Serviço",
    host: "Host",
    limit: "Limite",
    online: "Online",
    offline: "Offline",
    id_tenant: "ID do Tenant",
    devices: "Dispositivos",
    device: "Dispositivo",
    device_name: "Nome do Dispositivo",
    url: "URL",
    devices_count: "Contagem de Dispositivos",
    number_of_devices: "Número de Dispositivos",
    maximum_devices: "Dispositivos Máximos",
    on_server_status: "Status no Servidor",
    message: "Mensagem",
    camera: "Câmera",
    created_at: "Criado em",
    server_id: "ID do Servidor",
    server_uuid: "UUID do Servidor",
    logs: "Registros",
    id: "ID",
    uuid: "UUID",
    tenant: "Tenant",
    status_active: "Status Ativo",
    cameras_online: "Câmeras Online",
    start_date: "Data de Início",
    end_date: "Data de Fim",
    fire_threshold: "Limiar de Fogo",
    smoke_threshold: "Limiar de Fumaça",
    use_local_confirmation: "Inferência Local",
    restart_server: "Reiniciar Servidor",
    uuid_not_found: "UUID do servidor não encontrado",
    restarted_successfully: "Servidor reiniciado com sucesso",
    restart_error: "Erro ao reiniciar o servidor",
    fetch_error: "Erro ao obter as informações",
    delete_error: "Erro ao excluir",
    update_status_error: "Erro ao atualizar o status",
    STREAM_ONLINE: "Stream online e funcionando corretamente.",
    STREAM_CONNECTION_LOST: "Problemas de conexão no stream: intermitência ou perda de frames.",
    STREAM_HARD_DOWN: "Stream indisponível e não pôde ser recuperado.",
    STREAM_LOW_QUALITY: "Baixa qualidade do stream: bitrate insuficiente, baixa resolução ou perda de pacotes.",
    AUTH_ERROR: "Token RTSP inválido.",
  },
};
